module.exports = __webpack_public_path__ + "static/media/2-pennaya-vecherinka.53ed8e25.jpg";